import palette from "../palette"

export default {
  root: {
    padding: 0,
    borderRadius: 0,
    borderTop: `1px solid ${palette.common.tableBorder}`,
  },
}
